<template>
  <div class="container-fluid">
    <h3 v-if="loadSetting">
      Carregando...
    </h3>
    
    <div class="row" v-else>
      <div class="col-md-12">
        <div class="form-group">
          <label for="setting-name">Nome</label>
          <input v-model="setting.name" id="setting-name" class="form-control" :disabled="fieldDisabled">
        </div>
        
        <div class="form-group">
          <label for="setting-active" class="mr-2">Ativo</label>
          <input v-model="setting.active" id="setting-active" type="checkbox">
        </div>
        
        <div class="form-group" v-if="fieldDisabled">
          <label>Tipos</label>
          <input :value="setting.types.join(', ')" class="form-control" disabled="true"/>
        </div>
        
        <div class="form-group" v-else>
          <label for="setting-types">Tipos</label>
          <Select2 v-model="setting.types" id="setting-types" :options="optionTypes"/>
        </div>
        
        <div class="form-group">
          <label for="setting-payload">Payload</label>
          <textarea :value="toJson(setting.payload)"
                    id="setting-payload"
                    rows="10"
                    class="form-control"
                    ref="payload"
                    :disabled="fieldDisabled"
          />
        </div>
  
        <div class="form-group">
          <button class="btn btn-outline mr-3 px-4" @click="sendToIndex">
            Cancelar
          </button>
          
          <button @click="save" class="btn btn-primary px-4">
            Salvar
          </button>
        </div>
      </div>
    </div>
  
    <hr>
    <div class="row">
      <div class="col-md-12">
        <small>
          <p><b style="color: red">Importante!</b></p>
          <p>A <b>configuração</b> é imutável. Depois de criada só é possível <b>ativar</b> ou <b>desativar</b>.</p>
          <p>Não há limites na quantidade de <b>configurações</b>.</p>
          <p>Uma <b>configuração</b> pode ser aplicado para um ou até cinco tipos de documento fiscal</p>
          <p>O <b>payload</b> é a configuração que será aplicado no envio para a API.</p>
          
        </small>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import ModelMapper from '@/mixins/ModelMapper'
  import Select2 from '@/components/shares/Select2'

  const jsonValid = (payload) => {
    try {
      return JSON.parse(payload)
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }
  
  const confirmObjectType = (payload) => {
    payload = JSON.parse(payload)
    const documentVOList = payload.documentVOList
    
    if (!Array.isArray(documentVOList))
      return
    
    const messages = []
    documentVOList.forEach(document => {
      const documentObjects = document.documentObjects
      if (!Array.isArray(documentObjects))
        return
  
      documentObjects.forEach((object, index) => {
        if (object.objectTypeId === 2)
          messages.push(` -> Objeto na posição ${index + 1} com formato PDF(2)`)
        else if (object.objectTypeId === 29)
          messages.push(` -> Objeto na posição ${index + 1} com formato XML(29)`)
      })
    })
    
    if (messages.length === 0)
      return
    
    messages.unshift('Criando configuração com:')
    messages.push('Tem certeza?')
    
    return !confirm(messages.join('\n'))
  }
  
  export default {
    components: { Select2 },
    computed: {
      fieldDisabled() {
        return !!this.setting.id
      }
    },
    created() {
      const setting = this.loadNewSetting() || this.loadBySession()
      
      if (setting)
        return this.setSetting(setting)
        
      this.asyncTemplateShow(this.id, {
        after: ({model}) => this.setSetting(model)
      })
    },
    data: () => ({
      loadSetting: true,
      modelPathPrefix: 'unico_integration',
      nameModel: 'Setting',
      optionTypes: ['NFe', 'NFSe', 'CTe', 'CTeOS', 'GTVe'],
      setting: null,
    }),
    methods: {
      ...mapMutations(['setNameBreadcrumb']),
      buildData() {
        return { ...this.setting }
      },
      loadBySession() {
        const setting = this.$ss.get(this.id)
        
        if (setting && typeof setting === 'object') {
          this.$ss.remove(this.id)
          return setting
        } else
          return false
      },
      loadNewSetting() {
        if (this.id === 'new')
          return {
            active: true,
            name: '',
            payload: {},
            types: []
          }
        else
          return false
      },
      save() {
        const payload = this.$refs.payload.value
    
        if (!jsonValid(payload)) {
          this.$notify.add('JSON invalido!', { type: 'error' })
          return
        }

        if (!this.setting.id && confirmObjectType(payload))
          return

        this.setting.payload = JSON.parse(payload)
        this.asyncTemplateSave(this.setting, {
          after: ({model}) => {
            this.setting = model
            this.setNameBreadcrumb(model.name)
            this.$notify.add('Configuração salvo com sucesso!')
          }
        })
      },
      sendToIndex() {
        this.$router.push('/unico_integration/settings')
      },
      setSetting(setting) {
        this.setting = setting
        this.setNameBreadcrumb(setting.name || 'Novo')
        this.loadSetting = false
      },
      toJson(data) {
        return JSON.stringify(data, null, 2)
      }
    },
    mixins: [ModelMapper],
    name: 'Form',
    props: ['id']
  }
</script>

<style scoped>

</style>